module.exports = __webpack_public_path__ + "img/Angle-double-left.5056745c.svg";